// extracted by mini-css-extract-plugin
export default {"uaDetails":"UnplannedAbsence__uaDetails___FoZMC","tableContainer":"UnplannedAbsence__tableContainer___RamsP"};